<main>
    <div
        #diagramContainer
        class="w-full h-300 max-h-[600px] overflow-x-scroll overflow-y-hidden"
    ></div>
    
</main>
